// extracted by mini-css-extract-plugin
export default {"mCard":"NC-z","image":"OC-z","imageNoBackground":"PC-z","fullWidth":"QC-z"};